import React, { Component } from 'react'

import { Select } from '../../atoms/Forms'
import { replaceAccent } from '../../helpers/Formatter'

export default class Country extends Component {
   state = {
      countries: [],
   }

   componentWillMount() {
      this.loadCountries()
   }

   loadCountries() {
      import('./countries.json')
      .then(resp => {
          this.setState({
              countries: resp,
          })
      })

  }

  
   render() {
      var countries_key = this.props.language === "pt-BR" ? 'nome_pais' : 'nome_pais_int'
      let countries = this.state.countries.sort((a, b) =>
         replaceAccent(a[countries_key]) < replaceAccent(b[countries_key]) ? -1 : 1
      )
      return (
         <Select { ...this.props }>
            {this.props.children}
            {countries.map(country => 
                  <option key={country.sigla} value={country.sigla}> {
                     country[countries_key]
                  } </option>
            )}
         </Select>
      )
   }

}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/Forms/country.js